import currency_symbols from "../utils/currencyCodes";

cartAddonInit();

// cart addon close button
$(document).on("click", '[js-cart-addon="close"]', function (e) {
  e.preventDefault();

  const $this = $(this);

  $this.parents('[js-cart-addon="container"]').addClass("hidden");
  $this.parents("#drawer-cart").addClass("addon-closed");
});

export default function cartAddonInit(productId = false) {
  if ($('[js-cart-addon="container"]').length > 0) {
    const alsoBoughtContainer = $("body").find('[js-cart-addon="container"]');

    [...alsoBoughtContainer].forEach((container) => {
      let product_id = $(container).data("product-id");
      const productsList = $(container).find('[js-cart-addon="list"]');

      if (productId) {
        product_id = productId;
      }

      $.ajax({
        type: "get",
        url:
          "/recommendations/products.json?product_id=" +
          product_id +
          "&limit=3",
        success: (response) => {
          // recommended products array
          const products = response.products;
          let productsHtml = "";

          products.forEach((product) => {
            const isAvailable = product.available;

            let firstAvailable = product.variants.find((x) => x.available);

            if (firstAvailable === undefined) {
              firstAvailable = product.variants[0];
            }

            let buttonHtml = `<a js-quick-add data-id="${firstAvailable.id}" href="#" class="btn-simple">Add to bag</a>`;

            // check if product is sold out
            if (!isAvailable) {
              buttonHtml = `<a href="#" class="btn-simple btn-simple--warning">Out of Stock</a>`;
            }

            const productHtml = `
              <div class="cart-addon__product">
                <a class="cart-addon__product-image" href="${
                  product.url.split("?")[0]
                }">
                  <img class="lazyload" data-src="${
                    product.featured_image
                  }" alt="${product.title}">
                </a>

                <div class="cart-addon__content">
                  <h6>${product.title}</h6>

                  <p class="cart-addon__price price">
                    <span class="price__amount">
                      <span class="money">
                        ${
                          window.Shopify.currency.active
                            ? currency_symbols[window.Shopify.currency.active]
                            : "£"
                        }
                        ${(firstAvailable.price / 100).toFixed(2)}
                      </span>
                    </span>
                  </p>

                  ${buttonHtml}
                </div>
              </div>
              `;

            productsHtml += productHtml;
          });

          productsList.html(productsHtml);
          products.length > 0
            ? $(container).removeClass("hidden")
            : $(container).addClass("hidden");
        },
        error: () => {
          console.log("error with cart addon");
          $(container).addClass("hidden");
        },
      });
    });
  }
}
